import React from 'react';
import { Card, Form, Select, Input, Row, Col } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface ResponsesProps {
  form: FormInstance;
}

const Responses: React.FC<ResponsesProps> = ({ form }) => {
  const responseOptions = ['Agree', 'Disagree', 'No Opinion'];
  const yesNoOptions = ['Yes', 'No'];

  const employerActionOptions = [
    'Accommodation given was reasonable',
    'Action denied by Personnel',
    'All employees were searched',
    'Budget Cutbacks',
    'Complete Denial',
    'Customer Complaints',
    'Downgraded',
    'Drug Tests are mandatory when employees are suspect',
    'Failed Training',
    'Failure to Follow Orders',
    'Failure to Follow Procedures',
    'Failure to report actions of other employees',
    'Falsified records',
    'Followed established procedures',
    'Further investigation unnecessary',
    'Incident of misconduct',
    'Ineligible for auto/credit card',
    'Ineligible for clearances/credentials',
    'Ineligible for reassignment/detail',
    'Ineligible for timeoff/awards',
    'Input from Previous supervisor',
    'Insufficient/less education',
    'Insufficient/less experience',
    'It is your word against mine',
    'It would create a negative impact on the company budget',
    'Just angry and did not mean it',
    'Just Apologized',
    'Less or no directly related experience',
    'Low Production',
    'No Reason',
    'Nude Pictures shown to coworkers',
    'Others requested leave prior to you',
    'Physically unable to perform a job duty',
    'Policy allows desk searches at any time',
    'Poor attendance/tardiness',
    'Poor attitude with clients/outside contractors',
    'Poor attitude with co-workers',
    'Poor attitude with supervisors',
    'Poor communication between you and your supervisor',
    'Poor Interview skills',
    'Poor performance',
    'Position abolished/Reduction in force',
    'Position classified according to established standard',
    'Removed/Stole property',
    'Restructuring requires this action',
    'Risk of infecting others',
    'Showed inappropriate materials to others',
    'Specific attire would be distracting',
    'Spread rumours',
    'Start verbal or physical fights',
    'Supervisor had to meet deadlines/timeframes',
    'Talk too much in the workplace',
    'Talk too much on phone/visitors',
    'The other candidate had more enthusiasm',
    'Too much work to let you off',
    'Unsafe driving habits',
    'Violates union agreements',
    'You deserve it',
    'You have no leave time',
    'You spoke to me disrespectfully',
    'You are easier to replace than the accused',
    'The allegations were investigated and substantiated',
    'The allegations were investigated and found to be unfound',
    'Disciplinary action was taken immediately',
    'Steps have been taken to prevent further harassment',
    'A sexual harassment policy was in place but not distributed',
    'A sexual harassment policy was in place and distributed',
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <FormSection title="Responses" columns={3} className="response-section">
        <style dangerouslySetInnerHTML={{
          __html: `
          .response-section .ant-form-item-label {
            display: flex;
            align-items: flex-end;
            line-height: 1.2;
            min-height: 30px;
          }
          .response-section .ant-form-item-label > label {
            margin-bottom: 11px !important;
          }
          .response-section .ant-select-selector {
            height: 40px !important;
            min-height: 40px !important;
          }
          .response-section .ant-select-selection-item,
          .response-section .ant-select-selection-placeholder {
            line-height: 40px !important;
          }
          @media (min-width: 768px) {
            .response-section .ant-form-item-label {
              min-height: 55px;
              margin-bottom: 8px !important;
            }
            .response-section .ant-form-item-label > label {
              margin-bottom: 8px !important;
            }
            .response-section .ant-select-selector {
              height: 47px !important;
              min-height: 47px !important;
            }
            .response-section .ant-select-selection-item,
            .response-section .ant-select-selection-placeholder {
              line-height: 47px !important;
            }
          }
        `}} />
        <Form.Item
          label="What reason were you given for your employer's actions?"
          name={['responses_info', 'reason_given']}
        >
          <Select
            placeholder="Select"
            showSearch
            filterOption={(input, option) =>
              String(option?.children || '').toLowerCase().includes(input.toLowerCase())
            }
            suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}
          >
            {employerActionOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Your Response"
          name={['responses_info', 'your_response']}
        >
          <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
            {responseOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Do you have documented proof?"
          name={['responses_info', 'has_documented_proof']}
        >
          <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
            {yesNoOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Do you have any witnesses that will testify under oath?"
          name={['responses_info', 'has_witnesses']}
        >
          <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
            {yesNoOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>
      </FormSection>
    </div>
  );
};

export default Responses;

